import { useMemo } from "react";
import type { ICartMenuStorage } from "@/types";
import { useCartStorageRaw } from "@/components/cart/hooks/useCartStorageRaw";
import { parseCartMenuStorage } from "@/components/cart/helpers/cartStorage";

export const useCartMenuStorage = (menuId: number | null): ICartMenuStorage => {
  const raw = useCartStorageRaw(menuId);

  return useMemo(() => {
    return parseCartMenuStorage(raw);
  }, [raw]);
};
